/**
 * JS and CSS dynamic loader
 */
var DynamicScriptLoader = /** @class */ (function () {
    function DynamicScriptLoader() {
        var _this = this;
        this.log = function (t) {
            console.debug("ScriptLoader: " + t);
        };
        this.loadStyle = function (filename, callback) {
            // HTMLLinkElement
            var isEnlyteStyle = filename.includes("ImageViewerApp_Enlyte");
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            link.classList.add(isEnlyteStyle ? "iv-css-enlyte" : "iv-css-mitchell");
            link.onload = function () {
                _this.log('Loaded style "' + filename + '".');
                if (!isEnlyteStyle) {
                    link.disabled = true;
                }
                callback();
            };
            link.onerror = function () {
                _this.log('Error loading style "' + filename + '".');
            };
            _this.log("Loading style " + filename);
            link.href = filename;
            //Insert our styles at beginning to allow following styles to override
            var firstElement = _this.m_head.children[0];
            if (firstElement !== undefined && firstElement !== null) {
                _this.m_head.insertBefore(link, firstElement);
            }
            else {
                _this.m_head.appendChild(link);
            }
        };
        this.loadScript = function (i, callback) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = _this.m_js_files[i];
            var loadNextScript = function () {
                if (i + 1 < _this.m_js_files.length) {
                    _this.loadScript(i + 1, callback);
                }
                else {
                    callback();
                }
            };
            script.onload = function () {
                _this.log('Loaded script "' + _this.m_js_files[i] + '".');
                loadNextScript();
            };
            script.onerror = function () {
                _this.log('Error loading script "' + _this.m_js_files[i] + '".');
                loadNextScript();
            };
            _this.log('Loading script "' + _this.m_js_files[i] + '".');
            _this.m_head.appendChild(script);
        };
        this.loadStyles = function (callback) {
            var self = _this;
            var loadNextStyle = function (i) {
                if (i < self.m_css_files.length) {
                    _this.loadStyle(self.m_css_files[i], function () { return loadNextStyle(i + 1); });
                }
                else {
                    callback();
                }
            };
            loadNextStyle(0);
        };
        this.loadFiles = function (done) {
            //First load all styles, then load scripts one by one
            var self = _this;
            _this.loadStyles(function () { return self.loadScript(0, done); });
        };
        this.m_js_files = [];
        this.m_css_files = [];
        this.m_head = document.getElementsByTagName("head")[0];
    }
    DynamicScriptLoader.prototype.addFiles = function (files) {
        //Queue files for fetching
        for (var i = 0; i < files.length; ++i) {
            this.addFile(files[i]);
        }
    };
    DynamicScriptLoader.prototype.addFile = function (filename) {
        function contains(str, suffix) {
            if (str === null || suffix === null)
                return false;
            return str.indexOf(suffix) !== -1;
        }
        if (contains(filename, ".css")) {
            this.m_css_files.push(filename);
        }
        else if (contains(filename, ".js")) {
            this.m_js_files.push(filename);
        }
        else
            this.log('Error unknown filetype "' + filename + '".');
    };
    return DynamicScriptLoader;
}());
export { DynamicScriptLoader };
var LoadState;
(function (LoadState) {
    LoadState[LoadState["unloaded"] = 0] = "unloaded";
    LoadState[LoadState["loading"] = 1] = "loading";
    LoadState[LoadState["loaded"] = 2] = "loaded";
    LoadState[LoadState["failed"] = 3] = "failed";
})(LoadState || (LoadState = {}));
/**
 * @deprecated Future integrations should use ImageViewerLoaderV3
 *
 * Components that can load an image viewer
 */
var ImageViewerLoader = /** @class */ (function () {
    function ImageViewerLoader() {
    }
    ImageViewerLoader.GetScriptSource = function () {
        var scripts = document.getElementsByTagName("script");
        var index = scripts.length - 1;
        var myScript = scripts[index];
        var scriptSource = myScript.src;
        return scriptSource.substring(0, scriptSource.lastIndexOf("/")).replace("/scripts", "/");
    };
    ImageViewerLoader.BootStrap = function () {
        this.IVRoot = ImageViewerLoader.GetScriptSource();
    };
    /**
     * Return a promise that is called when the image viewer is loaded
     * @param container DOM container to create IV component in
     * @param sessionToken Session token to load for IV
     * @param dev deprecated, has no effect
     * @param disableUrlSupport True to stop modifying URL
     * @param allowAppd False to stop injecting AppD, true by default. Note: IV will override this value if appd is/isn't enabled (per environment).
     * @returns If browser supports a promise, this returns a promise with reference to the Image Viewer Object
     */
    ImageViewerLoader.LoadImageViewer = function (container, sessionToken, dev, // needs to be removed, but Angular SDK / other JS SDKs need a migration plan. 
    disableUrlSupport, allowAppd, onReady) {
        if (sessionToken === void 0) { sessionToken = null; }
        if (dev === void 0) { dev = false; }
        if (disableUrlSupport === void 0) { disableUrlSupport = false; }
        if (allowAppd === void 0) { allowAppd = true; }
        if (onReady === void 0) { onReady = null; }
        var self = this;
        window["MI-IV-SessionToken"] = sessionToken;
        if (typeof Promise !== "undefined") {
            return new Promise(function (resolve, reject) {
                ImageViewerLoader.LoadImageViewerNonPromise(container, sessionToken, disableUrlSupport, allowAppd, onReady, resolve, reject);
            });
        }
        else {
            return ImageViewerLoader.LoadImageViewerNonPromise(container, sessionToken, disableUrlSupport, allowAppd, onReady, function () { }, function () { });
        }
    };
    /**
     * Private function
     * @param container DOM container to create IV component in
     * @param sessionToken Session token to load for IV
     * @param dev True if DEV resources should be used
     * @param disableUrlSupport True to stop modifying URL
     * @param allowAppd False to stop injecting AppD, true by default. Note: IV will override this value if appd is/isn't enabled (per environment).
     * @param resolve Called when viewer loaded
     * @param reject Called if error occurs
     */
    ImageViewerLoader.LoadImageViewerNonPromise = function (container, sessionToken, disableUrlSupport, allowAppd, onReady, resolve, reject) {
        if (sessionToken === void 0) { sessionToken = null; }
        if (disableUrlSupport === void 0) { disableUrlSupport = false; }
        if (allowAppd === void 0) { allowAppd = true; }
        if (onReady === void 0) { onReady = null; }
        var self = this;
        // Only load if unloaded
        if (ImageViewerLoader.state == LoadState.unloaded || ImageViewerLoader.state == LoadState.failed) {
            ImageViewerLoader.log("loader was in a state of unload/failed. Triggering api/loader now");
            ImageViewerLoader.state = LoadState.loading;
            var xhr = new XMLHttpRequest();
            xhr.open("GET", self.IVRoot + "api/loader");
            xhr.onload = function () {
                if (xhr.status === 200) {
                    ImageViewerLoader.log("loaded HTML control");
                    var responseObject = JSON.parse(xhr.response);
                    var ScriptLoader = new DynamicScriptLoader();
                    // Append URL root to styles
                    var modifiedStyles = new Array();
                    for (var i = 0; i < responseObject.styles.length; i++) {
                        modifiedStyles.push(self.IVRoot + responseObject.styles[i]);
                    }
                    // Append URL to scripts
                    var modifiedScripts = new Array();
                    for (var i = 0; i < responseObject.scripts.length; i++) {
                        modifiedScripts.push(self.IVRoot + responseObject.scripts[i]);
                    }
                    // Load scripts and styles that we need
                    ScriptLoader.addFiles(modifiedStyles.concat(modifiedScripts));
                    // Load files, once done, start up viewer
                    ScriptLoader.loadFiles(function () {
                        // Finally, set html
                        container.innerHTML = responseObject.body;
                        ImageViewerLoader.state = LoadState.loaded;
                        if (!sessionToken) {
                            sessionToken = Utils.getURLVariable("token");
                        }
                        if (!sessionToken) {
                            var windowToken = window["MI-IV-SessionToken"];
                            if (windowToken != null) {
                                sessionToken = windowToken;
                            }
                        }
                        var shareRequested = Utils.getURLVariable("sharetoken");
                        window.imageControl = new ImageViewerApp(sessionToken, container, disableUrlSupport, shareRequested != null, onReady, responseObject.useCredentials === true, "" + self.IVRoot + responseObject.pdfjsWorkerScript);
                        resolve(window.imageControl);
                    });
                }
                else {
                    ImageViewerLoader.log("Request failed.  Returned status of " + xhr.status);
                    ImageViewerLoader.state = LoadState.failed;
                    reject("Error");
                }
            };
            xhr.send();
        }
        else if (ImageViewerLoader.state == LoadState.loaded) {
            window.imageControl.ChangeSession(sessionToken);
            resolve(window.imageControl);
        }
    };
    ImageViewerLoader.state = LoadState.unloaded;
    ImageViewerLoader.log = function (t) {
        console.log("ImageViewerLoader: " + t);
    };
    ImageViewerLoader.logError = function (t) {
        console.error("[Error] ImageViewerLoader: ", t);
    };
    return ImageViewerLoader;
}());
export { ImageViewerLoader };
/**
 * @deprecated Future integrations should use ImageViewerLoaderV3
 *
 *  Used to wrap ImageViewerLoader but without old arguments
 */
var ImageViewerLoaderV2 = /** @class */ (function () {
    function ImageViewerLoaderV2() {
    }
    ImageViewerLoaderV2.BootStrap = function () {
        ImageViewerLoader.BootStrap();
    };
    /**
   * Return a promise that is called when the image viewer is loaded
   * @param container DOM container to create IV component in
   * @param sessionToken Session token to load for IV
   * @param disableUrlSupport True to stop modifying URL
   * @param allowAppd False to stop injecting AppD, true by default. Note: IV will override this value if appd is/isn't enabled (per environment).
   * @returns If browser supports a promise, this returns a promise with reference to the Image Viewer Object
   */
    ImageViewerLoaderV2.LoadImageViewer = function (container, sessionToken, disableUrlSupport, allowAppd, onReady) {
        if (sessionToken === void 0) { sessionToken = null; }
        if (disableUrlSupport === void 0) { disableUrlSupport = false; }
        if (allowAppd === void 0) { allowAppd = true; }
        if (onReady === void 0) { onReady = null; }
        return ImageViewerLoader.LoadImageViewer(container, sessionToken, false, disableUrlSupport, allowAppd, onReady);
    };
    return ImageViewerLoaderV2;
}());
export { ImageViewerLoaderV2 };
var ImageViewerLoaderV3 = /** @class */ (function () {
    function ImageViewerLoaderV3() {
    }
    ImageViewerLoaderV3.BootStrap = function () {
        ImageViewerLoaderV2.BootStrap();
    };
    ImageViewerLoaderV3.LoadImageViewer = function (container, sessionToken, disableUrlSupport, onReady) {
        if (sessionToken === void 0) { sessionToken = null; }
        if (disableUrlSupport === void 0) { disableUrlSupport = false; }
        if (onReady === void 0) { onReady = null; }
        return ImageViewerLoaderV2.LoadImageViewer(container, sessionToken, disableUrlSupport, false, onReady);
    };
    return ImageViewerLoaderV3;
}());
export { ImageViewerLoaderV3 };
ImageViewerLoaderV3.BootStrap();
